<div class="home">
    <section class="header">
        <nlr-header [menuItem]="title"></nlr-header>
    </section>

    <section class="ff-container">
        <div class="wrap">
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <a
                routerLink="/plan-dashboard"
                routerLinkActive="router-link-active">
                <figure class="tint ff-items t2">
                    <button
                        id="myDashBoardBtn"
                        class="button button--splash button--round button--inverted">
                        <i class="nlrp-icon nlrp-icon-dashboard-plans"></i>
                        <span class="button--title">Plan Dashboard</span>
                    </button>
                </figure>
            </a>
            @if (!hasLodgeFieldRecordPermissions()) {
                <figure class="tint ff-items"></figure>
            }
            @if (hasLodgeFieldRecordPermissions()) {
                <a
                    [routerLink]="['/lodge-field-record']"
                    routerLinkActive="active"
                    nlrp-permissions="{permissions: 'LODGE_FIELD_RECORD'}">
                    <figure class="tint ff-items t2">
                        <button
                            id="lodgeFieldRecordBtn"
                            class="button button--splash button--round button--inverted">
                            <i class="nlrp-icon nlrp-icon-dashboard-field-records"></i>
                            <span class="button--title">Lodge Field Record</span>
                        </button>
                    </figure>
                </a>
            }
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            @if (['EXTRACT_CADASTRE'] | hasPermissions) {
                <a
                    routerLink="/extract-cadastre"
                    routerLinkActive="router-link-active">
                    <figure class="tint ff-items t2">
                        <button
                            id="extractCadastreBtn"
                            class="button button--splash button--round button--inverted">
                            <i class="extract-cadastre-icon"></i>
                            <span class="button--title">Extract Cadastre</span>
                        </button>
                    </figure>
                </a>
            } @else {
                <figure class="tint ff-items"></figure>
            }

            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <figure class="tint ff-items"></figure>
            <a
                routerLink="/user-account-details"
                routerLinkActive="router-link-active">
                <figure class="tint ff-items t2">
                    <button
                        id="userAccountDetailsBtn"
                        class="button button--splash button--round button--inverted">
                        <i class="nlrp-icon nlrp-icon-user"></i>
                        <span class="button--title">User Account Details</span>
                    </button>
                </figure>
            </a>
            @if (!hasMaintainFirmPermissions()) {
                <figure class="tint ff-items"></figure>
            }
            @if (hasMaintainFirmPermissions()) {
                <a
                    routerLink="/maintain-firm"
                    routerLinkActive="router-link-active"
                    nlrp-permissions="{permissions: 'MAINTAIN_FIRM'}">
                    <figure class="tint ff-items t2">
                        <button
                            id="maintainFirmBtn"
                            class="button button--splash button--round button--inverted">
                            <i class="nlrp-icon nlrp-icon-uni018C"></i>
                            <span class="button--title">Maintain Firm</span>
                        </button>
                    </figure>
                </a>
            }
            <div class="caption"><span>&copy;</span>Landgate aerial photograph - Willie Creek Broome</div>
        </div>
    </section>
    <section class="footer">
        <nlr-footer></nlr-footer>
    </section>
</div>
